var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwooshLargeDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "1390px",
    height: "187px",
    viewBox: "0 0 1390 187",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "swoosh (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.7040046%",
    y1: "50.0447905%",
    x2: "23.975%",
    y2: "50.0447905%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61BCBA",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ABEBD",
    stopOpacity: 0.7744,
    offset: "3.374261%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D1D1",
    stopOpacity: 0.5933,
    offset: "27.19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8E3E2",
    stopOpacity: 0.4234,
    offset: "49.55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1F0",
    stopOpacity: 0.2694,
    offset: "69.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FAFA",
    stopOpacity: 0.1365,
    offset: "87.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.04,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.3691204%",
    y1: "61.1045113%",
    x2: "77.6220602%",
    y2: "23.3906552%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD990",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD9B",
    stopOpacity: 0.7528,
    offset: "6.175281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8B6",
    stopOpacity: 0.6262,
    offset: "22.76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0CB",
    stopOpacity: 0.4945,
    offset: "40%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6DB",
    stopOpacity: 0.3573,
    offset: "57.96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBE5",
    stopOpacity: 0.211,
    offset: "77.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDE9",
    stopOpacity: 0.04,
    offset: "99.51%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.765778455%",
    y1: "51.2517204%",
    x2: "106.458946%",
    y2: "49.3004301%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACD58C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF45F",
    stopOpacity: 0.6,
    offset: "47.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF45F",
    stopOpacity: 0.2,
    offset: "91.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF45F",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.44201155%",
    y1: "50.1069444%",
    x2: "126.30085%",
    y2: "50.1069444%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47D3F",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE077",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE76",
    offset: "58.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD772",
    offset: "65.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB6A",
    offset: "71.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA60",
    offset: "77.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A353",
    offset: "82.78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68A45",
    offset: "87.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47D3F",
    offset: "90%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00455540955%",
    y1: "50.1069444%",
    x2: "100.026281%",
    y2: "50.1069444%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008974",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4D445",
    offset: "62.55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6E043",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.2955082%",
    y1: "50.1069444%",
    x2: "-6.17596666%",
    y2: "50.1069444%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61BCBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A4D8",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#426AB3",
    offset: "71.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#426AB3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.8085825%",
    y1: "50.1069444%",
    x2: "107.621373%",
    y2: "50.1069444%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3777BC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F67",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.3818108%",
    y1: "50.1069444%",
    x2: "-48.4960658%",
    y2: "50.1069444%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1D34A",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC4BF",
    stopOpacity: 0.2,
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC4BF",
    stopOpacity: 0.05,
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC4BF",
    stopOpacity: 0,
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC4BF",
    stopOpacity: 0.05,
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC4BF",
    stopOpacity: 0.2,
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C7AA",
    stopOpacity: 0.2883,
    offset: "78.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FCB87",
    stopOpacity: 0.4591,
    offset: "85.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2CF68",
    stopOpacity: 0.6075,
    offset: "91.98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD252",
    stopOpacity: 0.7261,
    offset: "96.92%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1D34A",
    stopOpacity: 0.8,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swoosh-(1)",
    transform: "translate(695.25, 93.05) scale(-1, 1) translate(-695.25, -93.05)translate(0.5, 0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432,93 L864,93 C864,93 836.4,113.8 816.6,129 C807.4,136.1 753.2,184.3 701.2,186.1 L595.2,186.1 C543.2,184.3 488.7,136.2 479.4,129 C459.6,113.8 432,93.1 432,93 L432,93 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,93 L864,93 C864,93 836.4,113.8 816.6,129 C807.4,136.1 753.2,184.3 701.2,186.1 L595.2,186.1 C543.2,184.3 488.7,136.2 479.4,129 C459.6,113.8 432,93.1 432,93 L432,93 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864,93 C864,93 929.2,47.2 936,42.4 C956.5,28.6 994.5,1.8 1051.3,0 L1213.3,0 C1270.1,1.8 1318.7,42.4 1318.7,42.4 L1389.4,93 L864,93 L864,93 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-4)",
    points: "816.6 129 1389.4 129 1389.5 93 864 93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.6,129 L864,93 L972.6,93 C972.6,93 1001.9,129 1044.9,129 L816.6,129 L816.6,129 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864,93 L816.6,129 L479.5,129 C459.7,113.8 432.1,93 432.1,93 L864,93 L864,93 Z",
    id: "Shape",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,129 C298.8,129 328.1,93 371.1,93 L432,93 C432,93 459.6,113.8 479.4,129 L298.8,129 L298.8,129 Z",
    id: "Shape",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,129 C298.8,129 328.1,93 371.1,93 L0,93 C9.1,100.5 48.1,129 104.7,129 L298.8,129 L298.8,129 Z",
    id: "Shape",
    fill: "url(#linearGradient-8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwooshLargeDevice);
export default __webpack_public_path__ + "static/media/swoosh_large_device.f468c45276da41b55de27a4e8f4c79ab.svg";
export { ForwardRef as ReactComponent };